import ButtonBordered from './common/Buttons/ButtonBordered';
import ButtonFilled from './common/Buttons/ButtonFilled';

interface DownloadModelsPopupProps {
    onCancel: () => void;
    downloadAllModels: () => void;
    downloadApprovedModels: () => void;
    availableModels: any;
    approvedModels: any;
}

const DownloadModelsPopup = ({ onCancel, downloadAllModels, downloadApprovedModels, availableModels, approvedModels }: DownloadModelsPopupProps) => {
    return (
        <div className="bg-white">
            <div className="text-blue-600 pt-6 pl-6 flex items-center ">
                <div className="bg-blue-200 w-8 h-8 inline-flex justify-center items-center mr-3 rounded-sm ">
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="40" height="40" rx="4" fill="#CFE1FF" />
                        <path
                            d="M25.0985 16.6664H23.3318V11.1109C23.3318 10.4998 22.8318 9.99976 22.2207 9.99976H17.7763C17.1651 9.99976 16.6651 10.4998 16.6651 11.1109V16.6664H14.8985C13.9096 16.6664 13.4096 17.8664 14.1096 18.5664L19.2096 23.6664C19.6429 24.0998 20.3429 24.0998 20.7763 23.6664L25.8763 18.5664C26.5763 17.8664 26.0874 16.6664 25.0985 16.6664ZM12.2207 27.7775C12.2207 28.3886 12.7207 28.8886 13.3318 28.8886H26.6651C27.2763 28.8886 27.7763 28.3886 27.7763 27.7775C27.7763 27.1664 27.2763 26.6664 26.6651 26.6664H13.3318C12.7207 26.6664 12.2207 27.1664 12.2207 27.7775Z"
                            fill="#2A55E5"
                        />
                    </svg>
                </div>
                Download Models
            </div>
            <div className=" shadow-md p-4  mx-6 mt-8 rounded-md">
                <div className="  flex justify-between items-center " style={{ width: '677px' }}>
                    <div className="">
                        <p className=" text-lg">Download available models</p>
                        <p className=" text-base">{availableModels.length} Models</p>
                    </div>
                    <div className=" w-48">
                        <ButtonFilled disabled={availableModels.length === 0} fullWidth label="Download Models" onClick={downloadAllModels} />
                    </div>
                </div>
            </div>
            <div className=" shadow-md p-4  mx-6 mt-4 mb-16 rounded-md">
                <div className="  flex justify-between items-center " style={{ width: '677px' }}>
                    <div className="">
                        <p className=" text-lg">Download approved models</p>
                        <p className=" text-base">{approvedModels.length} Models</p>
                    </div>
                    <div className=" w-48">
                        <ButtonFilled disabled={approvedModels.length === 0} fullWidth label="Download Models" onClick={downloadApprovedModels} />
                    </div>
                </div>
            </div>
            <div className="container flex justify-end p-4">
                <div className="flex justify-end gap-4 w-1/4">
                    <ButtonBordered fullWidth label="Cancel" onClick={onCancel} />
                </div>
            </div>
        </div>
    );
};

export default DownloadModelsPopup;
